import { fetchWrapper } from '@/_helpers';

/**
 * Fetch all prompt templates for a given team.
 * @param {Object} params
 * @param {string} params.teamId - The team ID to filter prompt templates.
 * @returns {Promise<any>}
 */
export async function getPromptTemplates({ teamId, archived = false, page = 1, searchText, searchType }) {
    return fetchWrapper.get(
        `prompt-templates?${teamId ? `team=${teamId}` : ''}&archived=${archived}&page=${page || 1}${searchText ? `&searchText=${searchText}` : ''}${searchType ? `&searchType=${searchType}` : ''}&limit=10`
    );
}

export async function getPromptTemplateById({ promptTemplateId }) {
    return fetchWrapper.get(`prompt-templates/${promptTemplateId}`);
}
/**
 * Create a new prompt template.
 * @param {Object} params
 * @param {Object} params.data - The prompt template data.
 * @returns {Promise<any>}
 */
export async function createPromptTemplate({ data }) {
    return fetchWrapper.post('prompt-templates', data);
}

/**
 * Update an existing prompt template.
 * @param {Object} params
 * @param {string} params.promptTemplateId - The ID of the prompt template to update.
 * @param {Object} params.data - The updated prompt template data.
 * @returns {Promise<any>}
 */
export async function updatePromptTemplate({ promptTemplateId, data }) {
    return fetchWrapper.put(`prompt-templates/${promptTemplateId}`, data);
}

/**
 * Archive a prompt template.
 * @param {Object} params
 * @param {string} params.promptTemplateId - The ID of the prompt template to archive.
 * @returns {Promise<any>}
 */
export async function archivePromptTemplate({ promptTemplateId }) {
    return fetchWrapper.put(`prompt-templates/${promptTemplateId}/archive/true`);
}

/**
 * Archive a prompt template.
 * @param {Object} params
 * @param {string} params.promptTemplateId - The ID of the prompt template to unarchive.
 * @returns {Promise<any>}
 */
export async function unarchivePromptTemplate({ promptTemplateId }) {
    return fetchWrapper.put(`prompt-templates/${promptTemplateId}/archive/false`);
}

/**
 * Permanently delete a prompt template.
 * @param {Object} params
 * @param {string} params.promptTemplateId - The ID of the prompt template to delete.
 * @returns {Promise<any>}
 */
export async function deletePromptTemplate({ promptTemplateId }) {
    return fetchWrapper.delete(`prompt-templates/${promptTemplateId}`);
}
